export enum ActionFailureReasonCode {
    General_UnexpectedError = 40,
    General_AccessDenied_Object = 41,
    General_AccessDenied_ApplicationSettingType = 42,
    General_Delete_InUse = 43,
    General_Delete_SystemObject = 44,
    General_NotFound = 45,
    General_SortExpressionNotValid = 46,
    General_InputParameterInvalid = 47,
    General_CaptchaNotValid = 48,
    General_InputParameterRequired = 49,
    General_SaveError = 50,
    General_DeleteError = 51,
    General_SaveContentLanguageLabelsError = 52,
    General_DeleteContentLanguageLabelsError = 53,
    General_SaveHistoryError = 54,
    General_AccessDenied_OnDeleteObject = 63,
    General_UpgradeInProcess = 65,
    General_DomainNotFound = 66,
    General_SendEmailFailed = 68,
    General_LicenseAgreementCustomerMustAccept = 70,
    General_MobileAppUsageDenied = 71,
    General_UnAuthorizedModule = 72,
    BusinessUnit_Save_EmptyUserBusinessAreasList = 301,
    BusinessUnit_Delete_OrphanUsers = 311,
    BusinessUnit_Delete_LastUnit = 312,
    Area_Delete_OrphanUnits = 401,
    Area_Move_OrphanUnits = 402,
    Area_Move_AccessRights = 403,
    CheckList_NoCurrentPeriod = 501,
    User_PasswordNotValid = 101,
    User_EndDateNotValid = 102,
    User_ResetPrefBusinessUnit_OnlyAvailableUnit = 103,
    User_NotFound = 104,
    User_MagicLinkNotFound = 110,
    User_EmailInconsistent = 111,
    User_Deactivated = 115,
    User_AccountLocked = 116,
    User_BusinessUnitDeactivated = 117,
    User_MagicLinkExpired = 120,
    User_MagicLinkUsed = 121,
    User_SendEmailOnSaveUserFailed = 122,
    User_Expired = 123,
    //User_AlreadySignedIn = 124,
    User_AccessRequestNotAccepted = 125,

    User_AccessRequestAlreadyAccepted = 132,
    User_AccessRequestAlreadyRejected = 133,

    User_LoginNameAlreadyExist = 157,
    User_LicenseAgreementMustAccept = 158,
    User_ConfidentialAgreementMustAccept = 159,

    User_TokenExpired = 170,
    User_TokenDeactivated = 171,

    Document_ImportHtmlError = 802,
    Document_RestoreTemplateDeleted = 803,
    MediaBank_FileSizeLimitExceeded = 1701,
    MediaBank_HiddenFromMediaBank_EditError = 1703,

    PK_UnknownError = 7601,
    PK_ExternalRequestError = 7602,

    Baloo_UnknownError = 7701,
    Baloo_ExternalRequestError = 7702,

    CustomerBilling_SendInvoice_InvalidInvoiceDeliveryMethodType = 601,
    CustomerBilling_SendInvoice_InvalidReceiverEmail = 602,
    CustomerBilling_SendInvoice_SmtpError = 603,

    CustomImportSystemObjects_InputDataError = 10401,

    Onboarding_DeleteElementInUse = 120001,
}
